module.exports = __webpack_public_path__ + "f470a309899f278fb269395c5c55809b.MP3";